import { render, staticRenderFns } from "./IssueDashboard.vue?vue&type=template&id=bab0844c"
import script from "./IssueDashboard.vue?vue&type=script&lang=js"
export * from "./IssueDashboard.vue?vue&type=script&lang=js"
import style0 from "./IssueDashboard.vue?vue&type=style&index=0&id=bab0844c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports